import Cookies from "../vendor/js.cookie";

$('#modalNewsletter').on('hidden.bs.modal', function (event) {
    Cookies.set('hideNewsletterSignup', 'true', { expires: 30 });
});

if (Cookies.get('hideNewsletterSignup') != 'true') {
    setTimeout(() => {
        $('#modalNewsletter').modal('show');
    }, 5000);
}

